// 各ルートのタイトル・説明文 (SEO/OGP)。
// ビルド時プリレンダリング (scripts/prerender.mjs) と SPA のタブタイトル同期
// (Layout) の両方から使うため、Node がそのまま import できる素の ESM JS で書く。
// 型は routeMeta.d.ts を参照。

/** OGP 等のプレーンテキスト文脈用に、インライン数式の TeX 記法を落とす。 */
export function stripTex(text) {
  return text
    .replace(/\\[()]/g, '')
    .replace(/\\[a-zA-Z]+\s*/g, '')
    .replace(/[{}]/g, '');
}

/** ページタイトルにサイト名を付ける (ホーム以外)。 */
function withSite(siteTitle, pageTitle) {
  return `${pageTitle} - ${siteTitle}`;
}

/**
 * 全ルートのメタ情報 (プリレンダリング対象の列挙)。
 * 順序は任意。path は正規化済み (末尾スラッシュ無し)。
 */
export function routeMetas(index) {
  const siteTitle = stripTex(index.site.hero.title);
  const metas = [
    {
      path: '/',
      title: siteTitle,
      description: stripTex(index.site.hero.lead),
      type: 'website',
    },
    {
      path: '/link',
      title: withSite(siteTitle, 'リンク集'),
      description: '関連サイトへのリンク集です。',
      type: 'website',
    },
    {
      path: '/licenses',
      title: withSite(siteTitle, 'フォントライセンス'),
      description: '本サイトが配信するフォントのライセンス表示です。',
      type: 'website',
    },
  ];
  for (const category of index.categories) {
    metas.push({
      path: `/${category.key}`,
      title: withSite(siteTitle, stripTex(category.title)),
      description: stripTex(category.lead),
      type: 'website',
    });
    for (const child of category.children) {
      metas.push({
        path: `/${category.key}/${child.key}`,
        title: withSite(siteTitle, stripTex(child.title)),
        description: stripTex(child.description[0] ?? category.lead),
        type: 'website',
      });
      for (const article of child.articles) {
        metas.push({
          path: `/${article.section}/${article.slug}`,
          title: withSite(siteTitle, stripTex(article.title)),
          description: stripTex(article.abstract),
          type: 'article',
        });
      }
    }
  }
  for (const work of index.solutions) {
    metas.push({
      path: `/solutions/${work.key}`,
      title: withSite(siteTitle, `${stripTex(work.title)}の解答集`),
      description: stripTex(work.description[0] ?? ''),
      type: 'website',
    });
    const groups = [
      ...work.books.map((b) => ({
        prefix: `${b.key}/`,
        label: `${b.title} `,
        problems: b.problems,
      })),
      { prefix: '', label: '', problems: work.problems },
    ];
    for (const group of groups) {
      for (const problem of group.problems) {
        const name = `${stripTex(group.label)}${stripTex(problem.title)}の解答`;
        metas.push({
          path: `/solutions/${work.key}/${group.prefix}${problem.path}`,
          title: withSite(siteTitle, name),
          description: `${stripTex(work.title)} ${name}です。`,
          type: 'article',
        });
      }
    }
  }
  return metas;
}

/** pathname に対応するメタ情報。未知のルートはサイト既定を返す。 */
export function routeMetaFor(index, pathname) {
  const path = pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const found = routeMetas(index).find((m) => m.path === path);
  if (found) {
    return found;
  }
  return {
    path,
    title: stripTex(index.site.hero.title),
    description: stripTex(index.site.hero.lead),
    type: 'website',
  };
}
